import React, { useState, useEffect } from 'react';

import {
    Tabs,
    Table,
} from 'antd';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import CssBaseline from '@material-ui/core/CssBaseline';

import NavMenu from 'components/NavMenu';
import TextEvents from 'app/components/TextEvents';
import WorkCycleForm from 'app/components/WorkCycleForm';
import CreateWorkCycle from 'app/components/CreateWorkCycle';
import EditWorkCycle from 'app/components/EditWorkCycle';
import WorkCycleTableContainer from 'app/containers/WorkCycleTableContainer';

import EditQuestionContainer from 'app/containers/EditQuestionContainer';

import { useStyles, styles } from './WorkCycleScreenStyles';
import { clearWorkCycle } from 'app/actions/WorkCycleActions';
import { useDispatch, useSelector } from 'react-redux';

export default function WorkCycleScreen(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { TabPane } = Tabs;
    const [sorter, setSorter] = useState({});
    const [pagination, setPagination] = useState({
        defaultCurrent: 1,
        defaultPageSize: 25,
        pageSize: 25,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: [
            '25',
            '50',
            '100'
        ],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    });

    const { siteId } = useSelector(state => state.Auth);

    const [filter, setFilter] = useState([]);
    const [activeKey, setTabBar] = useState('1');
    const [idTest, setIdTest] = useState();
    const tabs = { '1': 'Bandeja de ciclo de trabajo', '2': 'Nuevo ciclo de trabajo', '3': `${siteId === 'HUB' ? 'Editar' : 'Visualizar'} Ciclo de trabajo`}
    const [formData, setFormData] = useState({});
    useEffect(() => {
        return () => {
            dispatch(clearWorkCycle());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isAdmin={true} header='Ciclo de trabajo' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Ciclo de trabajo
                        </Link>
                        <TextEvents
                            text={tabs[activeKey]}
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Tabs tabBarStyle={{ margin: 0 }} type='card' defaultActiveKey='1' activeKey={activeKey} className={classes.tabContainer} onChange={tab => setTabBar(tab)}>
                    <TabPane tab='Buscar' key='1'>
                        <Paper className={classes.paper} key='1'>
                            {/* <Button onClick={() => getEvaluation() }>GetEvaluation</Button> */}
                            <WorkCycleForm filter={filter} setFilter={setFilter} setTab={setTabBar} formData={formData} setFormData={setFormData} />
                            <div style={styles.baseVerticalMargin}>
                                <WorkCycleTableContainer
                                    classes={classes}
                                    setTab={setTabBar}
                                    setIdTest={setIdTest}
                                    sorter={sorter}
                                    setSorter={setSorter}
                                    pagination={pagination}
                                    setPagination={setPagination}
                                    formData={formData}
                                >
                                    {(params) => {
                                        return (
                                            <div>
                                                <Table
                                                    columns={params.cols}
                                                    rowKey={item => String(item.idTest)}
                                                    dataSource={filter.length > 0 ? filter : params.workCycle}
                                                    loading={params.isLoading}
                                                    onChange={params.handleTableChange}
                                                    pagination={pagination}
                                                    scroll={{ x: 400, y: (height - 395) }}
                                                    size={"small"}
                                                />
                                            </div>
                                        )
                                    }}
                                </WorkCycleTableContainer>
                            </div>
                        </Paper>
                    </TabPane>
                    {activeKey === '2' ?
                        <TabPane tab='Nuevo' key='2' className={classes.tab}>
                            <Paper className={classes.paper} key='2'>
                                <CreateWorkCycle setTab={setTabBar} formData={formData} setFormData={setFormData} />
                            </Paper>
                        </TabPane> : ''}
                    {activeKey === '3' ?
                        <TabPane tab={siteId === 'HUB' ? 'Editar' : 'Visualizar'} key='3' className={classes.tab}>
                            <Paper className={classes.paper} key='2'>
                                <WorkCycleTableContainer idTest={idTest}>
                                    {(params) => {
                                        const filterParam = params.workCycle.find(function (element) {
                                            return element.idTest === idTest;
                                        });
                                        return (
                                            <div>
                                                <EditQuestionContainer filterData={filterParam}>
                                                    {(editParams) => {
                                                        return (
                                                            <div>
                                                                <EditWorkCycle setTab={setTabBar} idTest={idTest} editParam={filterParam} questions={editParams.testQuestions} formData={formData} setFormData={setFormData} />
                                                            </div>
                                                        )
                                                    }
                                                    }
                                                </EditQuestionContainer>
                                            </div>
                                        )
                                    }}
                                </WorkCycleTableContainer>
                            </Paper>
                        </TabPane> : ''}
                </Tabs>
            </div>
        </div>
    )
}